import { render, staticRenderFns } from "./PersonalAreaPage.vue?vue&type=template&id=84159d62&scoped=true&"
import script from "./PersonalAreaPage.vue?vue&type=script&lang=js&"
export * from "./PersonalAreaPage.vue?vue&type=script&lang=js&"
import style0 from "./PersonalAreaPage.vue?vue&type=style&index=0&id=84159d62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84159d62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VTextField})
